import Vue from 'vue'
import './plugins/axios'
import App from './app'
import vuetify from './plugins/vuetify'
import AxiosPlugin from './plugins/axios'
import { Vue2Storage } from 'vue2-storage'

Vue.config.productionTip = false

Vue.use(AxiosPlugin)
Vue.use(Vue2Storage, {
  ttl: 365 * 60 * 60 * 24 * 1000 // 1 year
})

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
